import { classNames } from "primereact/utils";

import Molhado from "@/assets/icons/icone-barco-molhado.svg?react";
import Seco from "@/assets/icons/icone-barco-seco.svg?react";

import { ICONE_BARCO_ROTULO } from "./icone-barco.constants";
import styles from "./icone-barco.module.scss";
import type { IconeBarcoProps } from "./types-icone-barco";

const SVG_POR_CONDICAO = { seco: Seco, molhado: Molhado };

export function IconeBarcoView({ condicao, className, ...rest }: IconeBarcoProps) {
  const Svg = SVG_POR_CONDICAO[condicao];

  return (
    <Svg
      className={classNames(styles.icone, className)}
      role="img"
      aria-label={ICONE_BARCO_ROTULO[condicao]}
      data-condicao={condicao}
      {...rest}
    />
  );
}
